import type { ReactElement } from 'react';
import { Flex, Grid, Div, DivSkeleton } from '@fastnorth/kraken/components/layout';
import SummaryStatSkeleton from './components/SummaryStat.skeleton';

const StatisticsSkeleton = (): ReactElement => {
  return (
    <Flex data-testid={'statistics-skeleton'} className={'flex-col gap-7'}>
      <DivSkeleton grayVariant={300} className="h-7 w-[200px]" />

      <Grid className={'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5'} gap={'6'}>
        {Array.from({ length: 3 }, (_, index) => (
          <SummaryStatSkeleton key={index} />
        ))}
      </Grid>

      <Flex className={'flex-col md:flex-row md:flex-nowrap gap-11'}>
        <Div className={'w-full'}>
          <DivSkeleton grayVariant={300} className="h-7 w-[200px] mb-3" />
          <DivSkeleton grayVariant={300} className="h-[220px] w-full" />
        </Div>
        <DivSkeleton grayVariant={300} className={'h-full w-[2px]'} />
        <Div className={'w-full'}>
          <DivSkeleton grayVariant={300} className="h-7 w-[200px] mb-3" />
          <DivSkeleton grayVariant={300} className="h-[220px] w-full" />
        </Div>
      </Flex>
    </Flex>
  );
};

export default StatisticsSkeleton;
